import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DispositionType } from '../../../../../generated/generated-types';
import { GenericEnumDropDownComponent } from '../../../../../shared/controls/generic-enum-drop-down/generic-enum-drop-down.component';
import { ProductToStoragePlaceListWidgetComponent } from '../product-to-storage-place-link-list-widget/product-to-storage-place-link-list-widget.component';

/**
 * Lager › Einstellungen: the product's disposition type (Bestelldispo, DEV-3270) above its minimum/target stock per storage place.
 * The dropdown has no form control of its own – the host writes the product model, the detail page's Save button persists it.
 */
@Component({
  selector: 'app-product-storage-settings',
  template: `
    <div class="flex h-full min-h-0 flex-col gap-3 pt-2">
      <div class="w-full shrink-0 px-1 md:w-1/4" data-testid="product-storage-settings-disposition-type">
        <label class="mb-0 block">{{ 'product.disposition-type' | translate }}</label>
        <app-generic-enum-drop-down
          enumName="DispositionType"
          translationPrefix="DispositionType"
          dataTestId="product-storage-settings-disposition-type-select"
          [autoLoad]="true"
          [searchable]="false"
          [showClear]="false"
          [value]="dispositionType()"
          (valueChange)="onSelect($event)"
        />
      </div>
      <div class="flex min-h-0 flex-1 flex-col" data-testid="product-storage-settings-minimum-target-stock">
        <label class="mb-0 block px-1">{{ 'product.minimum-target-stock' | translate }}</label>
        <app-product-to-storage-place-list-widget class="min-h-0 flex-1" [productIdInputSig]="productId()" />
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TranslatePipe, GenericEnumDropDownComponent, ProductToStoragePlaceListWidgetComponent],
})
export class ProductStorageSettingsComponent {
  productId = input<string>();
  dispositionType = input<DispositionType | null | undefined>();
  dispositionTypeChange = output<DispositionType>();

  onSelect(value: DispositionType | null): void {
    // the clear button is off; an empty value only comes from the control's own reset
    if (value && value !== this.dispositionType()) this.dispositionTypeChange.emit(value);
  }
}
